module.exports = __webpack_public_path__ + "img/xl_xianlai.411359a9.png";